module.exports = __webpack_public_path__ + "static/img/Jack-Bostock.8f2a55c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jack-Bostock.jpg
// module id = seLK
// module chunks = 0